import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FiltersService {
	private _filtersChanged = new BehaviorSubject<any>(this.getCurrentFilters());
	filtersChanged$ = this._filtersChanged.asObservable();

	getCurrentFilters() {
		return JSON.parse(localStorage.getItem('filtersProducts') || '{}');
	}

	updateFilters(newFilters: any) {
		localStorage.setItem('filtersProducts', JSON.stringify(newFilters));
		this._filtersChanged.next(newFilters);
	}

	clearFilters() {
		const cleared = {
			brands: [],
			categories: [],
			max_price: 999999,
			min_price: 0,
			search: "",
		};
		localStorage.setItem('filtersProducts', JSON.stringify(cleared));
		this._filtersChanged.next(cleared);
	}

	removeFilterKey(key: string): void {
		const current = this.getCurrentFilters();

		switch (key) {
			case 'brands':
				current.brands = [];
				break;
			case 'categories':
				current.categories = [];
				break;
			default:
				break;
		}

		localStorage.setItem('filtersProducts', JSON.stringify(current));
		this._filtersChanged.next(current);
	}
	
}
